<template>
    <div>
        <nav-bar></nav-bar>
        <b-container fluid class="main-container">
            <router-view></router-view>
        </b-container>
    </div>
</template>

<script>
    import NavBar from "../components/NavBar"
    export default {
        name: "MainView",
        components: {
            'nav-bar': NavBar,
        }
    }
</script>

<style scoped>
    .main-container {
        padding: 70px;
    }
</style>